import { OneTrustSettingsButton } from "components";
import type { ReactStoryblokComponent } from "types/storyblok";

export const OneTrustSettingsButtonAdapter = ({
  blok: { buttonText },
  sbEditable,
}: ReactStoryblokComponent<{ buttonText: string }>) => (
  <OneTrustSettingsButton buttonText={buttonText} sbEditable={sbEditable} />
);
